import React from "react";
import { Facebook, Instagram, Youtube, Twitter, Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../mock";

const Footer = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/images/logo.webp" alt="logo" />
            <h3>{CONTACT.name}</h3>
            <p>No.1 Astrologer in Bangalore — 18+ years of guiding souls through Vedic astrology, palmistry, kundali, vastu &amp; spiritual remedies from KR Puram, Bengaluru.</p>
          </div>
          <div>
            <h4>Quick Links</h4>
            <div className="footer-links">
              <a href="#home">Home</a>
              <a href="#about">About Guruji</a>
              <a href="#services">Services</a>
              <a href="#homas">Special Homas</a>
              <a href="#reviews">Reviews</a>
            </div>
          </div>
          <div>
            <h4>Services</h4>
            <div className="footer-links">
              <a href="#services">Palmistry Reading</a>
              <a href="#services">Horoscope Reading</a>
              <a href="#services">Vastu Consultation</a>
              <a href="#services">Black Magic Removal</a>
              <a href="#homas">Special Homas</a>
            </div>
          </div>
          <div>
            <h4>Get in Touch</h4>
            <div className="footer-links">
              <a href={`tel:${CONTACT.callNumber}`}><Phone size={14} style={{ display:"inline", marginRight:6 }} />{CONTACT.callDisplay}</a>
              <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer"><MessageCircle size={14} style={{ display:"inline", marginRight:6 }} />{CONTACT.whatsappDisplay}</a>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </div>
            <div className="social-row" style={{ marginTop: 14 }}>
              <a href="#" aria-label="Facebook"><Facebook size={16} /></a>
              <a href="#" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="#" aria-label="YouTube"><Youtube size={16} /></a>
              <a href="#" aria-label="Twitter"><Twitter size={16} /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {CONTACT.name}. All rights reserved.</span>
          <span>Sri Sai Raghvendra Astro · KR Puram, Bengaluru</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
